import React from 'react';
import toast from 'lib/utils/toast';
import { AWARD_TYPES } from 'lib/constants/award';
import { useMobileOrder } from 'lib/hooks/useMobileOrder';
import awardPrizeService from 'lib/services/awardPrizeService';
import { useMobileStore } from 'lib/store/mobileStore';
import { validMobile } from 'lib/utils/util';
import { report } from 'lib/utils/dataReport';
import { ATTA_GATEWAY_MOBILE, ATTA_REPORT } from 'lib/constants/atta';
import { useGlobalStore } from 'lib/store';
import { closeModal, showModal } from 'lib/components/Modal';
import { useDialogKeyboard } from 'lib/hooks/useDialogKeyboard';
import Protocol from '../Protocol';
import './index.scss';

const MobileInput = ({ type }) => {
  const updateInputMobile = useMobileStore((state) => state.updateInputMobile);
  const mobileInput = useMobileStore((state) => state.inputMobile);
  const useGatewayMobile = useMobileStore((state) => state.useGatewayMobile);
  const updateGatewayMobile = useMobileStore((state) => state.updateGatewayMobile);
  const { mobileInputModalImg, mobileInputModalButtonText } = useGlobalStore((state) => state);
  const { orderFlowPackage } = useMobileOrder();
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (mobileInput !== '' && !validMobile(mobileInput)) {
      toast.info('输入正确手机号才能领专属好礼~');
    }
    report(ATTA_REPORT.MOBILE_INPUT.SHOW);
  }, []);

  const orderPackage = async () => {
    if (!useGatewayMobile && !validMobile(mobileInput)) {
      toast.info('输入正确手机号才能领专属好礼~');
      return;
    }
    // 获取普通礼包ID
    const giftList = awardPrizeService.getAllGiftData();
    const giftInfo = giftList.find((c) => c.giftType === AWARD_TYPES.NORMAL);
    report(ATTA_REPORT.MOBILE_INPUT.CLICK);
    await orderFlowPackage(giftInfo?.actId);
  };

  useDialogKeyboard({ onEnter: orderPackage, onEscape: closeModal });

  const inputMobile = (inputValue: string) => {
    updateInputMobile(inputValue);
    if (validMobile(inputValue)) {
      const reportObj = {
        mobile: inputValue,
      };
      if (type) {
        reportObj['eventRefer'] =
          type === AWARD_TYPES.MUST ? ATTA_REPORT.RECEIVE_PRIZE.GIFT : ATTA_REPORT.RECEIVE_PRIZE.LOTTERY;
      }
      report(ATTA_REPORT.ORDER.INPUT_FINISH_POP, reportObj);
    }
  };

  const reset = () => {
    report(ATTA_GATEWAY_MOBILE.RESET_CLICK);
    updateGatewayMobile('', false);

    if (inputRef.current) {
      inputRef.current.focus(); // 点击“点击修改”时聚焦输入框
    }
  };

  const inputValueToShow = useMobileStore((state) => state.getInputValueToShow());

  return (
    <div className="mobile-input-dialog">
      <div className="mobile-input-dialog__header">
        <div className="mobile-input-dialog__header__close" onClick={closeModal}></div>
        <div className="mobile-input-dialog__header-title">输入手机号才能领取专属豪礼哦~</div>
      </div>
      <div className="mobile-input-dialog__content">
        <div className="mobile-input-order">
          <img src={mobileInputModalImg} alt="mobileInputModalImg" className="mobile-input-order__image" />
        </div>
        <div className="mobile-input-dialog__footer">
          <input
            ref={inputRef}
            className="mobile-input-order__input"
            type="tel"
            name="mobile-order"
            placeholder="请输入手机号"
            value={inputValueToShow}
            onChange={(e) => inputMobile(e.target.value)}
            maxLength={11}
            onFocus={reset}
          />
          {useGatewayMobile ? (
            <div className="reset-mobile" onClick={reset}>
              点击修改
            </div>
          ) : null}
          <div className="mobile-input-order__button" onClick={orderPackage}>
            {mobileInputModalButtonText || '一键领取'}
          </div>
          {useGatewayMobile ? (
            <div className="protocol-in-dialog">
              <Protocol />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export const showOrderMobileInput = (btnType?: string) => showModal(<MobileInput type={btnType} />);

export default MobileInput;
